import React, { useCallback, useEffect, useState } from "react";
import "../leaveHistory.css";
import DashboardGreeting from "../DashboardGreeting";
import { useStateContext } from "../../contexts/ContextProvider";
import SearchIcon from "../../assets/images/search.svg";
import FilterIcon from "../../assets/images/filter.svg";
import ViewIcon from "../../assets/images/view.svg";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import moment from "moment";
import "./employee.css";

import AuthService from "../../services/auth.service";

import DataTableComponent from "../Charts/DatatableComponent";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import ApplyCompoff from "./ApplyCompoff";
import UpdateCompoff from "./UpdateCompoff";

import { Link } from "react-router-dom";
import Delete from "../common/CustomModals/Delete";
import HolidayShiftService from "../../services/holidayshift.service";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ApproveHolidayShift from "./ApproveHolidayShift";
import Success from "../common/CustomModals/Success";
import HolidayShiftFilterModal from "../common/HolidayShiftFilterModal";
import RejectHolidayShift from "./RejectHolidayShift";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpdateLogHours from "./UpdateLogHours";

const LeaveApplicationAction = ({
  setUpdateModal,
  setUpdateLoghours,
  setDeleteModal,
  rowData,
  setSelectedData,
  user,
  tabIndex,
  setApprove,
  setReject,
}) => {
  return (
    <>
      {tabIndex === 0 ? (
        <div className="d-flex gap-2">
          {(rowData.rM_isapproved === "0" || rowData.rM_isapproved === "") &&
          (rowData.hR_isapproved === "0" || rowData.hR_isapproved === "") ? (
            <>
              {" "}
              <span>
                <img
                  src={EditIcon}
                  onClick={(e) => {
                    setUpdateModal(true);
                    setSelectedData(rowData);
                  }}
                  alt=""
                />
              </span>
              <span>
                <img
                  src={DeleteIcon}
                  onClick={(e) => {
                    setDeleteModal(true);
                    setSelectedData(rowData);
                  }}
                  alt=""
                />
              </span>
            </>
          ) : (
            <>
              <span>
                <img
                  src={EditIcon}
                  onClick={(e) => {
                    setUpdateLoghours(true);
                    setSelectedData(rowData);
                  }}
                  alt=""
                  title="Add Log Hours"
                />
              </span>
            </>
          )}
        </div>
      ) : (
        <>
          {(user.role === "2" &&
            rowData.rM_isapproved === "0" &&
            rowData.hR_isapproved === "0") ||
          (user.role === "1" && rowData.hR_isapproved === "0") ? (
            <>
              <div className="action">
                <button
                  className="approve"
                  onClick={(e) => {
                    setApprove(true);
                    setSelectedData(rowData);
                  }}
                >
                  Approve
                </button>
                <button
                  className="reject"
                  onClick={(e) => {
                    setReject(true);
                    setSelectedData(rowData);
                  }}
                >
                  Reject
                </button>
              </div>
            </>
          ) : (
            <>----</>
          )}
        </>
      )}
    </>
  );
};

const CompOff = () => {
  const user = AuthService.getCurrentUser();
  const navHeading = "Holiday Shift";

  const [tabIndex, setTabIndex] = useState(
    user.role === "1" || user.role === "4" ? 1 : 0
  );

  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const currentDate = new Date();

  const { filterBy, setFilterBy, success, setSuccess } = useStateContext();

  const [holidayShiftData, setHolidayShiftData] = useState([]);
  const [myHolidayShiftData, setMyHolidayShiftData] = useState([]);

  const [heading, setHeading] = useState("");

  const initialData = {
    project: "",
    employee: "",
    date: "",
    formatedDate: "",
    status: "",
  };

  const [details, setDetails] = useState(initialData);
  const [requestOn, setRequestOn] = useState("");

  const [applyModal, setApplyModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

   const [updateLoghours, setUpdateLoghours] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  // const holidayShift = tabIndex === 0 ? myHolidayShiftData : holidayShiftData;

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

  // Convert "H:MM" into minutes
  function toMinutes(timeStr) {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + (m || 0);
  }

  // Convert minutes back to "H:MM"
  function toHHMM(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}:${m.toString().padStart(2, "0")}`;
  }

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    const data = tabIndex === 0 ? myHolidayShiftData : holidayShiftData;

    console.log(data, "data");
    const filteredData = data.filter(
      (row) =>
        (row.name && row.name.toLowerCase().includes(keyword)) ||
        (row.project && row.project.toLowerCase().includes(keyword)) ||
        (row.module && row.module.toLowerCase().includes(keyword))
    );

    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const fetchCompoffData = useCallback(() => {
    if (user && user.role !== "3") {
      HolidayShiftService.getAllShiftHR()
        .then((resp) => {
          if (resp.data) {
            const filteredData = resp.data.map((item) => ({
              ...item,
              rM_isapproved: item.rM_isapproved !== "" ? item.rM_isapproved : "0",
              hR_isapproved: item.hR_isapproved !== "" ? item.hR_isapproved : "0",
              workinghrs: toHHMM(
                item.reqdetails.reduce(
                  (sum, item2) => sum + toMinutes(item2.workinghrs),
                  0
                )
              ),
            }));
            setHolidayShiftData(filteredData);
          }
        })
        .catch((e) => console.log(e));
    }

    if (user && user.role !== "1") {
      const payload = {
        empid: user && user.empid,
      };

      HolidayShiftService.getShiftbyEmpid(payload)
        .then((resp) => {
          if (resp.data) {
            const filteredData = resp.data.map((item) => ({
              ...item,
              rM_isapproved: item.rM_isapproved !== "" ? item.rM_isapproved : "0",
              hR_isapproved: item.hR_isapproved !== "" ? item.hR_isapproved : "0",
              workinghrs: toHHMM(
                item.reqdetails.reduce(
                  (sum, item2) => sum + toMinutes(item2.workinghrs),
                  0
                )
              ),
            }));
            setMyHolidayShiftData(filteredData);
          }
        })
        .catch((e) => console.log(e));
    }
  }, [user.role]);

  useEffect(() => {
    fetchCompoffData();
  }, [fetchCompoffData]);

  const [date, setDate] = useState(new Date());

  const handleDateChange = (e) => {
    setDate(e.value);
  };

  const actionStatus = [
    {
      class: "pending",
      name: "Pending",
    },
    {
      class: "approved",
      name: "Approved",
    },
    {
      class: "rejected",
      name: "Rejected",
    },
  ];

  const columns = [
    {
      name: "Employee Name",
      selector: (row) => row.name,
      cell: (row) => (
        <>
          <span title={`${row.name}`}>{`${row.name}`}</span>
        </>
      ),
      sortable: true,
      omit: user.role === "3" || tabIndex === 0,
    },
    {
      name: "Project",
      selector: (row) => row.project,
      cell: (row) => (
        <>
          <span title={`${row.project}`}>{`${row.project}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Module",
      selector: (row) => row.module,
      cell: (row) => (
        <>
          <span title={`${row.module}`}>{`${row.module}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Request On",
      selector: (row) => row.requestOn,
      cell: (row) => (
        <>
          <span
            title={`${moment(new Date(row.requestOn)).format("D MMM, YYYY")}`}
          >{`${moment(new Date(row.requestOn)).format("D MMM, YYYY")}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Working Hours",
      selector: (row) => row.workinghrs,
      cell: (row) => (
        <>
          <span
            title={`${row.workinghrs} Hours`}
          >{`${row.workinghrs} Hours`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Work Duration",
      selector: (row) => row.workduration,
      cell: (row) => (
        <>
          <span
            title={`${row.workduration} Days`}
          >{`${row.workduration} Days`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "RM Approval",
      selector: (row) => row.status,
      cell: (row) => (
        <>
          <div
            className={`status ${
              row.rM_isapproved !== ""
                ? actionStatus[row.rM_isapproved].class
                : "pending"
            }`}
          >
            <span
              title={`${
                row.rM_isapproved !== ""
                  ? actionStatus[row.rM_isapproved].name
                  : "Pending"
              }`}
            >{`${
              row.rM_isapproved !== ""
                ? actionStatus[row.rM_isapproved].name
                : "Pending"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: "HR Approval",
      selector: (row) => row.status,
      cell: (row) => (
        <>
          <div
            className={`status ${
              row.hR_isapproved !== ""
                ? actionStatus[row.hR_isapproved].class
                : "pending"
            }`}
          >
            <span
              title={`${
                row.hR_isapproved !== ""
                  ? actionStatus[row.hR_isapproved].name
                  : "Pending"
              }`}
            >{`${
              row.hR_isapproved !== ""
                ? actionStatus[row.hR_isapproved].name
                : "Pending"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: "View Details",
      selector: (row) => row.actionStatusHR,
      cell: (row) => (
        <>
          <span>
            <Link
              to={"/HolidayShiftDetails"}
              state={{
                rowData: row,
                redirectBack: "/holidayShift",
              }}
            >
              <img src={ViewIcon} alt="" />
            </Link>
          </span>
        </>
      ),
    },
    {
      name: "Action",
      selector: (row) => row.actionStatusHR,
      cell: (row) => (
        <>
          <LeaveApplicationAction
            setUpdateModal={setUpdateModal}
            setUpdateLoghours={setUpdateLoghours}
            setDeleteModal={setDeleteModal}
            rowData={row}
            setSelectedData={setSelectedData}
            user={user}
            tabIndex={tabIndex}
            setApprove={setApprove}
            setReject={setReject}
          />
        </>
      ),
      sortable: true,
      width: "175px",
    },
  ];

  const deleteHolidayShift = (selectedData) => {
    console.log(selectedData, "selectedData");

    const payload = {
      requestid: selectedData.reqdetails[0].requestid,
    };

    HolidayShiftService.deleteHolidayShift(payload).then((resp) => {
      if (resp.data) {
        setDeleteModal(false);
        toast.success("Holiday Shift Deleted Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchCompoffData()
      }
    })
  };

  const handleFilter = () => {
    let filteredData = tabIndex === 0 ? myHolidayShiftData : holidayShiftData;

    const objectValues = {
      projectid: details.project,
      empid: details.employee,
      requestOn: details.date,
      rM_isapproved: details.status,
      hR_isapproved: details.status,
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null
      )
    );

    filteredData = filteredData.filter((item) =>
      Object.entries(nonEmptyDetails).every(
        ([detailsKey, value]) => item[detailsKey] === value
      )
    );

    setFilter(true);
    setFilteredData(filteredData);
  };

  const clearFilter = () => {
    setFilter(false);
    setDetails(initialData);
    setRequestOn("");
  };

  return (
    <>
      <div className="dashboard-container leave-history">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <ToastContainer />
        <div className="filterBarNew filterBar mb-4">
          <div className="d-flex">
            <div className="searchBar">
              <input
                type="text"
                placeholder={
                  user.role === "1" || user.role === "4"
                    ? "Search by Employee, Project or Module Name"
                    : user.role === "2" && tabIndex === 1
                    ? "Search by Employee, Project or Module Name"
                    : "Search by Project or Module Name"
                }
                value={search}
                onChange={handleSearch}
              />
              <span>
                <img src={SearchIcon} alt="" />
              </span>
            </div>
          </div>

          <div className="sort-filter filter">
            <div className="new-calendar-type flex justify-content-center">
              <Calendar
                value={date}
                onChange={handleDateChange}
                view="month"
                dateFormat="MM, yy"
                style={{ height: "100%" }}
                showIcon
                maxDate={currentDate}
              />
            </div>
            <div className="filter" onClick={showFilter}>
              <img src={FilterIcon} alt="" />
            </div>
            {user.role === "2" || user.role === "3" ? (
              <div className="action">
                <button
                  className="apply"
                  onClick={(e) => {
                    setApplyModal(true);
                  }}
                >
                  <span>
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1548_1543)">
                        <path
                          d="M5.58304 7.03675C6.83278 7.03675 7.84952 6.02001 7.84952 4.77027C7.84952 3.52046 6.83278 2.50372 5.58304 2.50372C4.33324 2.50372 3.3165 3.52046 3.3165 4.77027C3.3165 6.02001 4.3333 7.03675 5.58304 7.03675ZM5.58304 3.59082C6.23337 3.59082 6.76242 4.11994 6.76242 4.77027C6.76242 5.42059 6.23337 5.94965 5.58304 5.94965C4.93265 5.94965 4.4036 5.42059 4.4036 4.77027C4.4036 4.11988 4.93271 3.59082 5.58304 3.59082ZM11.4911 16.0905V18.9528C11.4911 19.253 11.2478 19.4964 10.9476 19.4964H2.42411C2.12389 19.4964 1.88056 19.253 1.88056 18.9528V18.3172C1.88056 18.0169 2.12389 17.7736 2.42411 17.7736C2.72433 17.7736 2.96766 18.0169 2.96766 18.3172V18.4093H10.404V16.6341H4.6029C4.30268 16.6341 4.05935 16.3908 4.05935 16.0905C4.05935 15.7903 4.30268 15.547 4.6029 15.547H10.9476C11.2478 15.547 11.4911 15.7904 11.4911 16.0905ZM21.4564 13.1977H16.391V11.8825H20.3672C20.6675 11.8825 20.9108 11.6392 20.9108 11.3389V5.42029C20.9108 5.12007 20.6675 4.87674 20.3672 4.87674H11.3278C11.0276 4.87674 10.7843 5.12007 10.7843 5.42029V11.3389C10.7843 11.6392 11.0276 11.8825 11.3278 11.8825H15.304V13.1977H2.9159L2.97871 11.0991C2.9975 10.4713 3.20549 9.00923 4.72719 8.99377C4.7368 8.99371 4.74634 8.99335 4.75582 8.99274C4.76772 8.99353 4.77974 8.99395 4.79188 8.99395H6.44439C6.4459 8.99395 6.44747 8.99395 6.44904 8.99395C7.96156 9.01569 8.16865 10.4727 8.18743 11.0992C8.19643 11.3993 8.44695 11.6348 8.74705 11.6263C9.04715 11.6173 9.28305 11.3668 9.27411 11.0667C9.21704 9.16396 8.1085 7.92364 6.45 7.90679C6.44427 7.90667 6.43865 7.90679 6.43291 7.90685H4.79188C4.78046 7.90685 4.76905 7.90721 4.75775 7.90794C4.74398 7.90703 4.73009 7.90661 4.7162 7.90679C3.05759 7.92364 1.94911 9.16396 1.89216 11.0667L1.82838 13.1978H0.54355C0.243329 13.1978 0 13.4411 0 13.7413C0 14.0415 0.243329 14.2849 0.54355 14.2849H1.79577L1.76442 15.3313C1.75548 15.6313 1.99139 15.8818 2.29149 15.8908C2.29704 15.8909 2.30254 15.8911 2.30803 15.8911C2.6007 15.8911 2.84222 15.6583 2.85104 15.3637L2.88335 14.2849H15.8363C15.8437 14.285 15.8513 14.285 15.8587 14.2849H21.4564C21.7567 14.2849 22 14.0415 22 13.7413C22 13.4411 21.7567 13.1977 21.4564 13.1977ZM11.8714 10.7954V5.96384H19.8237V10.7954H11.8714Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1548_1543">
                          <rect width="22" height="22" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Apply Holiday Shift</span>
                </button>
              </div>
            ) : null}
          </div>
        </div>

        {user.role === "2" && (
          <>
            <Tabs
              selectedIndex={tabIndex}
              onSelect={(index) => setTabIndex(index)}
            >
              <TabList>
                <Tab
                  className={
                    tabIndex === 0
                      ? "react-tabs__tab active"
                      : "react-tabs__tab"
                  }
                >
                  My Request
                </Tab>
                <Tab
                  className={
                    tabIndex === 1
                      ? "react-tabs__tab active"
                      : "react-tabs__tab"
                  }
                >
                  Team Request
                </Tab>
              </TabList>
              <TabPanel>
                <DataTableComponent
                  columns={columns}
                  data={myHolidayShiftData}
                />
              </TabPanel>
              <TabPanel>
                <DataTableComponent
                  columns={columns}
                  data={filter ? filteredData : holidayShiftData}
                />
              </TabPanel>
            </Tabs>
          </>
        )}

        {user.role === "3" ? (
          <>
            <DataTableComponent
              columns={columns}
              data={filter ? filteredData : myHolidayShiftData}
            />
          </>
        ) : null}

        {user.role === "1" || user.role === "4" ? (
          <>
            <DataTableComponent
              columns={columns}
              data={filter ? filteredData : holidayShiftData}
            />
          </>
        ) : (
          <></>
        )}

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <HolidayShiftFilterModal
              details={details}
              setDetails={setDetails}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              requestOn={requestOn}
              setRequestOn={setRequestOn}
              tabIndex={tabIndex}
            />
          </div>
        </div>

        {user.role !== "1" && (
          <>
            <div
              className={`${applyModal ? "modal-overlay" : ""}`}
              onClick={(e) => {
                setApplyModal(false);
              }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <ApplyCompoff
                  applyModal={applyModal}
                  setApplyModal={setApplyModal}
                  fetchCompoffData={fetchCompoffData}
                />
              </div>
            </div>

            <div
              className={`${updateModal ? "modal-overlay" : ""}`}
              onClick={(e) => {
                setUpdateModal(false);
              }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <UpdateCompoff
                  updateModal={updateModal}
                  setUpdateModal={setUpdateModal}
                  selectedData={selectedData}
                  fetchCompoffData={fetchCompoffData}
                />
              </div>
            </div>

            {/* updateLoghours */}

            <div
              className={`${updateLoghours ? "modal-overlay" : ""}`}
              onClick={(e) => {
                setUpdateLoghours(false);
              }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <UpdateLogHours
                  updateLoghours={updateLoghours}
                  setUpdateLoghours={setUpdateLoghours}
                  selectedData={selectedData}
                  fetchCompoffData={fetchCompoffData}
                />
              </div>
            </div>

            <div
              className={`${deleteModal ? "modal-overlay" : ""}`}
              onClick={(e) => {
                setDeleteModal(false);
              }}
            >
              <div className="" onClick={(e) => e.stopPropagation()}>
                <Delete
                  heading="Are you sure you want to delete this holiday shift !"
                  para="Deleting this holiday shift will remove all its details and also delete it
              from the receiver's dashboard"
                  showDelete={deleteModal}
                  setShowDelete={setDeleteModal}
                  remove={() => deleteHolidayShift(selectedData)}
                />
              </div>
            </div>
          </>
        )}

        <div
          className={`${approve ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setApprove(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <ApproveHolidayShift
              selectedData={selectedData}
              approve={approve}
              setApprove={setApprove}
              setSuccess={setSuccess}
              setHeading={setHeading}
              fetchData={fetchCompoffData}
            />
          </div>
        </div>

        <div
          className={`${reject ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setReject(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <RejectHolidayShift
              selectedData={selectedData}
              reject={reject}
              setReject={setReject}
              setSuccess={setSuccess}
              setHeading={setHeading}
              fetchData={fetchCompoffData}
            />
          </div>
        </div>

        <div
          className={`${success ? "modal-overlay success-modal-overlay" : ""}`}
          onClick={() => {
            setSuccess(false);
          }}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <Success heading={heading} para="" redirect="/leaveRequest" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompOff;
